import { Box, Grid, makeStyles, Typography } from "@material-ui/core";
import React, { useState } from "react";
import ItemModal from "./ItemModal";
import PlaceHolder from "./placeholder.png";
const useStyles = makeStyles((theme) => ({
  itemsContainer: {
    height: "auto",
  },
  container: {
    // width: "inherit",
    // backgroundColor: "green",
    height: "auto",
    paddingLeft: "110px",
    paddingRight: "110px",
  },

  gridBox: {
    width: "100%",
    height: "100%",
    // borderRadius: "5px",
    // borderColor: "black",
    // borderStyle: "solid",
    position: "relative",
    padding: "10px",
    border: "1px solid rgb(233,237,244)",
    borderRadius: "5px",
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
      borderRadius: "5px",
      cursor: "pointer",
    },
  },
  imgBox: {
    borderRadius: "5px",
    width: "100%",
    height: "100%",
    maxHeight: "170px",
    boxShadow: "2px 2px 10px 0 rgba(0,0,0, 0.2)",
    [theme.breakpoints.between("lm", "lm")]: {
      maxHeight: "127px",
    },
    [theme.breakpoints.between("md", "md")]: {
      maxHeight: "88px",
    },
  },
  imgTitle: {
    position: "absolute",
    margin: "auto",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    backgroundColor: "white",
    width: "90%",
    height: "auto",
    fontSize: "18px",
    fontWeight: "bold",
    [theme.breakpoints.between("lm", "lm")]: {
      fontSize: "14px",
    },
    [theme.breakpoints.between("md", "md")]: {
      fontSize: "11px",
    },
  },
  gridItem: {
    textAlign: "center",
  },
  gridContainer: {
    width: "100%",
    height: "100%",
    maxHeight: "inherit",
    overflowY: "auto",
    backgroundColor: "rgba(255,255,255,0.3)",
    borderRadius: "5px",
    boxShadow: "2px 2px 10px 0 rgba(0,0,0, 0.2)",
    padding: "40px 25px",
    [theme.breakpoints.between("md", "md")]: {
      padding: "25px 15px",
    },
  },
}));
export default function MainContent({ title, vegData }) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [subItem, setSubItem] = useState();
  const handleOpen = (id) => {
    setSubItem(vegData.filter((x) => x._id === id));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box className={classes.gridContainer}>
      {subItem && (
        <ItemModal
          open={open}
          handleOpen={handleOpen}
          handleClose={handleClose}
          subItem={subItem[0].items}
          title={title}
          subTitle={subItem[0].title}
        />
      )}
      <Grid container spacing={3}>
        {vegData &&
          vegData.map((veggie) => {
            const placeholderImage = veggie.category_image
              ? veggie.category_image
              : PlaceHolder;
            // const lit = ImageChecker(veggie._id);

            return (
              <Grid
                item
                md={3}
                xs={12}
                key={veggie._id}
                className={classes.gridItem}
              >
                <Box
                  className={classes.gridBox}
                  onClick={() => handleOpen(veggie._id)}
                >
                  <img
                    src={placeholderImage}
                    alt="carrot"
                    className={classes.imgBox}
                  />
                  <Typography className={classes.imgTitle} variant="body1">
                    {veggie.title}
                  </Typography>
                </Box>
              </Grid>
            );
          })}
      </Grid>
    </Box>
  );
}
